import { Box, Button, Loader, Text } from '@wix/design-system';
import React, { useState } from 'react';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
import { PremiumDomainBadge } from '../PremiumDomainBadge/PremiumDomainBadge';
import { PricingSection } from '../Pricing/PricingSection';
import { parseDomain } from '@wix/domains-serverless-interface';
export const TldAlternativeCard = _ref => {
  let {
    recommendation,
    onClick,
    disabled,
    dataHook,
    useMobileLayout = false
  } = _ref;
  const {
    t
  } = DomainSearchSuiteModule.internals.useTranslations();
  const [isClickLoading, setIsClickLoading] = useState(false);
  const {
    domain = '',
    premium = false,
    price
  } = recommendation;
  const {
    sld,
    tld
  } = parseDomain(domain);
  const handleClick = async () => {
    if (!onClick) {
      return;
    }
    setIsClickLoading(true);
    try {
      await onClick(recommendation);
    } finally {
      setIsClickLoading(false);
    }
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    boxSizing: "border-box",
    minWidth: useMobileLayout ? undefined : '220px',
    borderRadius: "12px",
    border: "1px solid #DEDEDE",
    padding: "14px SP6",
    flex: 1,
    maxWidth: useMobileLayout ? undefined : '320px',
    gap: "SP1",
    align: "space-between",
    dataHook: dataHook
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "6px"
  }, premium && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(PremiumDomainBadge, null)), /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    as: "span"
  }, sld, /*#__PURE__*/React.createElement(Text, {
    weight: "bold"
  }, ".", tld))), /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    align: "space-between",
    verticalAlign: "bottom",
    gap: "SP1",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    marginBottom: "3px"
  }, /*#__PURE__*/React.createElement(PricingSection, {
    pricing: price,
    tld: tld,
    domainName: domain,
    useMobileLayout: true
  })), /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    priority: "secondary",
    skin: "dark",
    disabled: disabled || isClickLoading,
    onClick: handleClick,
    dataHook: dataHook ? `${dataHook}-button` : undefined
  }, isClickLoading ? /*#__PURE__*/React.createElement(Loader, {
    size: "tiny"
  }) : t('domain_search_suite.domain_gate.suggestions.card.cta'))));
};
//# sourceMappingURL=TldAlternativeCard.js.map